import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ProductForm from "./ProductForm";
import { BeerFormStateEdit } from "../../../constants/types";
import { productEndPoints } from "../../../constants/endpoints";
import axios from "axios";
import Breadcrumbs from "../../../common/Breadcrumbs";
import { fetchProductData } from "../../../api/productDataAPI";

import {
  mapBackendToFormState,
  updateProductService,
} from "../../../service/productService";

import Toast from "../../../common/Toast";
const EditProduct: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const userData = location.state?.userData || {};
  const [formData, setFormData] = useState<BeerFormStateEdit>({
    beerName: userData.beerName ?? "",
    quantity: userData.quantity ?? 0,
    description: userData.description ?? "",
    price: userData.price ?? 0,
    fileUpload: userData.file ?? [],
    existingImages: userData.images ?? [],
    abv: userData.abv || "",
    ibu: userData.ibu || "",
  });

  const orgId = localStorage.getItem("orgId");

  useEffect(() => {
    const fetchProductDataAsync = async () => {
      try {
        const fetchProduct = await fetchProductData(
          id,
          productEndPoints.getProducts
        );
        // Handle the fetched data if needed
        const mappedData = await mapBackendToFormState(fetchProduct);
        setFormData({ ...mappedData });
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    };

    fetchProductDataAsync();
  }, [id]);

  const [showToast, setShowToast] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);

  const handleSubmit = async (data: BeerFormStateEdit) => {
    setError(false);
    try {
      const response = await updateProductService(data, id ?? "");

      const success = response?.message === "Product updated successfully";
      if (success) setMessage("Product details have been updated successfully");
      else {
        setError(true);
        setMessage(
          "Unable to update product details. Please check your input and try again"
        );
      }
      setShowToast(true);
      success && setTimeout(() => navigate(`/${orgId}/seller/products`), 3000);
    } catch (error) {
      setMessage(
        "Unable to update product details. Please check your input and try again"
      );
      setError(true);
      if (axios.isAxiosError(error)) {
        console.error(
          "Error creating product:",
          error.response?.data || error.message
        );
      } else {
        console.error("Unexpected error:", error);
      }
      setShowToast(true);
    }
  };

  return (
    <div style={{ background: "#f6f6f6" }}>
      <Breadcrumbs
        paths={["Products", "Edit Product Details"]}
        links={["/seller/products", "/seller/edit-product"]}
      />
      <Toast
        setShowToast={setShowToast}
        showToast={showToast}
        toastMessage={message}
        error={error}
      />
      <div>
        {formData.beerName && (
          <ProductForm
            formTitle="Edit Product Details"
            beerName={formData.beerName}
            description={formData.description}
            price={formData.price}
            fileUpload={formData.fileUpload}
            quantity={formData.quantity}
            onSubmit={handleSubmit}
            existingImages={formData.existingImages}
            buttonTextOne="Save"
            buttonTextTwo="Reset"
            isEdit={true}
            abv={formData.abv}
            ibu={formData.ibu}
          />
        )}
      </div>
    </div>
  );
};

export default EditProduct;
